enum Action {
    LOGIN = "LOGIN",
    CONFIRM_ACCOUNT = "CONFIRM_ACCOUNT",
    RESEND_CONFIRMATION = "RESEND_CONFIRMATION",
    FETCH_CURRENT_STATEMENT = "FETCH_CURRENT_STATEMENT",
    SIGNUP = "SIGNUP",
    LOGOUT = "LOGOUT",
    LOAD_ADDRESS = "LOAD_ADDRESS",
    SAVE_ADDRESS = "SAVE_ADDRESS"
}
export default Action;
